module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-center align-items-center form-data"
  }, [_c('div', [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Forgot your password")]), _vm._v(" "), _c('div', {
    staticClass: "dark mb-5"
  }, [_vm._v("Enter your email address below and we'll get you back on track.")]), _vm._v(" "), _c('form', {
    class: ['shaded', _vm.status],
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.email.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your email here"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      }, _vm.$v.email.$touch],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.email.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.email.email) ? _c('span', [_vm._v("Must be a valid email")]) : _vm._e(), _vm._v(" "), (!_vm.$v.email.emailExists) ? _c('span', [_vm._v("We couldn't find this email on our database")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "btn action widest full",
    attrs: {
      "type": "submit",
      "value": "Request reset link"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "fs-smaller back",
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_vm._v("\n                Back to sign in\n            ")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a0ed85c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0ed85c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ForgotPassword.vue
// module id = 2564
// module chunks = 0